import useCartStore from "../../utils/cartStore";
import { useState } from "react";
import GuidePoster from "../../components/GuidePoster";

const GOUTS_COEUR = [
  { id: "blanc",   label: "Blanc",    color: "#F5F0E8" },
  { id: "noir",    label: "Noir",     color: "#1a1a1a" },
  { id: "au-lait", label: "Au Lait",  color: "#C68642" },
];

const GOUTS_ROSES = [
  { id: "praline-royal",   label: "Praliné Royal",   image: "/images/gouts_roses/praline-royal.png" },
  { id: "nuit-gourmand",   label: "Nuit Gourmand",   image: "/images/gouts_roses/nuit-gourmand.png" },
  { id: "neige-croquante", label: "Neige Croquante", image: "/images/gouts_roses/neige-croquante.png" },
  { id: "rose-orient",     label: "Rose d'Orient",   image: "/images/gouts_roses/rose-orient.png" },
  { id: "coeur-lait-pistache",          label: "Cœur de Lait Cœur Pistache",       image: "/images/gouts_roses/coeur-lait-pistache.png" },
  { id: "coeur-lait-praline-noisette",  label: "Cœur de Lait Praliné Noisette",    image: "/images/gouts_roses/coeur-lait-praline-noisette.png" },
];

const GOUTS_MENDIANTS = [
  { id: "noir",  label: "Noir",  color: "#1a1a1a" },
  { id: "lait",  label: "Lait",  color: "#C68642" },
  { id: "blanc", label: "Blanc", color: "#F5F0E8" },
  { id: "gold",  label: "Gold",  color: "#D4AF37" },
  { id: "ruby",  label: "Ruby",  color: "#9B1B30" },
];

const GOUTS_FRAISES = [
  { id: "lait",  label: "Chocolat au Lait", color: "#C68642" },
  { id: "blanc", label: "Blanc",            color: "#F5F0E8" },
  { id: "gold",  label: "Gold",             color: "#D4AF37" },
];

const REPARTITION_ROSES_VIDE     = Object.fromEntries(GOUTS_ROSES.map((g) => [g.id, 0]));
const REPARTITION_MENDIANTS_VIDE = Object.fromEntries(GOUTS_MENDIANTS.map((g) => [g.id, 0]));
const REPARTITION_FRAISES_VIDE   = Object.fromEntries(GOUTS_FRAISES.map((g) => [g.id, 0]));

// ─── Modèle 1 : Pivoine + 3 Roses + 6 Mendiants ─────────────────────────────
const CoeurModel1 = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);
  const [goutCoeur, setGoutCoeur] = useState(null);
  const [goutPivoine, setGoutPivoine] = useState(null);
  const [repartitionRoses, setRepartitionRoses] = useState({ ...REPARTITION_ROSES_VIDE });
  const [repartitionMendiants, setRepartitionMendiants] = useState({ ...REPARTITION_MENDIANTS_VIDE });
  const [demande, setDemande] = useState("");

  const totalRoses = Object.values(repartitionRoses).reduce((a, b) => a + b, 0);
  const restantRoses = 3 - totalRoses;
  const rosesPret = totalRoses === 3;

  const totalMendiants = Object.values(repartitionMendiants).reduce((a, b) => a + b, 0);
  const restantMendiants = 6 - totalMendiants;
  const mendiantsPret = totalMendiants === 6;

  const pret = goutCoeur && goutPivoine && rosesPret && mendiantsPret;

  const handleIncreaseRose = (id) => { if (restantRoses <= 0) return; setRepartitionRoses((p) => ({ ...p, [id]: p[id] + 1 })); };
  const handleDecreaseRose = (id) => { if (repartitionRoses[id] <= 0) return; setRepartitionRoses((p) => ({ ...p, [id]: p[id] - 1 })); };
  const handleIncreaseMendiant = (id) => { if (restantMendiants <= 0) return; setRepartitionMendiants((p) => ({ ...p, [id]: p[id] + 1 })); };
  const handleDecreaseMendiant = (id) => { if (repartitionMendiants[id] <= 0) return; setRepartitionMendiants((p) => ({ ...p, [id]: p[id] - 1 })); };

  const buildDescription = () => {
    const roses = GOUTS_ROSES.filter((g) => repartitionRoses[g.id] > 0).map((g) => `${repartitionRoses[g.id]}x ${g.label}`).join(", ");
    const mendiants = GOUTS_MENDIANTS.filter((g) => repartitionMendiants[g.id] > 0).map((g) => `${repartitionMendiants[g.id]}x ${g.label}`).join(", ");
    return [
      `Coeur : ${goutCoeur?.label}`,
      `Pivoine : ${goutPivoine?.label}`,
      `Roses (3) : ${roses}`,
      `Mendiants (6) : ${mendiants}`,
      demande.trim() ? `Demande : ${demande.trim()}` : null,
    ].filter(Boolean).join("\n");
  };

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart({
      id: `coeur-modele1-${Date.now()}`,
      name: "Cœur en Chocolat Pivoine & Roses",
      price: 32,
      image: "/images/coeurs/coeur-chocolat.jpg",
      category: "Cœurs en Chocolat",
      description: buildDescription(),
    }, quantity);
    setGoutCoeur(null);
    setGoutPivoine(null);
    setRepartitionRoses({ ...REPARTITION_ROSES_VIDE });
    setRepartitionMendiants({ ...REPARTITION_MENDIANTS_VIDE });
    setDemande("");
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <img src="/images/coeurs/coeur-chocolat.jpg" alt="Cœur Pivoine & Roses" className="w-full h-64 object-contain rounded-xl mb-4" />
      <h2 className="text-xl font-semibold mb-1">Cœur Pivoine & Roses</h2>
      <p className="text-gray-500 text-sm mb-3">Contient 1 Fleur Pivoine, 3 Roses et 6 Mendiants</p>
      <p className="text-xl font-bold mb-5">32 €</p>

      {/* Goût du coeur */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goût du Cœur :</p>
        <div className="flex gap-2 flex-wrap">
          {GOUTS_COEUR.map((g) => (
            <button key={g.id} onClick={() => setGoutCoeur(g)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-all ${goutCoeur?.id === g.id ? "border-primary ring-2 ring-primary ring-offset-1" : "border-gray-200 hover:border-gray-400"}`}>
              <span className="w-5 h-5 rounded-full border border-gray-300 flex-shrink-0" style={{ background: g.color }} />
              {g.label}
            </button>
          ))}
        </div>
        {!goutCoeur && <p className="text-xs text-amber-600 mt-1">Veuillez choisir le goût du cœur</p>}
      </div>

      {/* Goût pivoine */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goût de la Fleur Pivoine :</p>
        <GuidePoster image="/images/guides/guide-gouts.jpg" label="Voir le guide des goûts" />
        <div className="flex flex-wrap gap-2">
          {GOUTS_ROSES.map((g) => (
            <button key={g.id} onClick={() => setGoutPivoine(g)}
              className={`flex items-center gap-2 px-2 py-1 rounded-lg border text-xs transition-all ${goutPivoine?.id === g.id ? "border-primary ring-2 ring-primary ring-offset-1" : "border-gray-200 hover:border-gray-400"}`}>
              <img src={g.image} alt={g.label} className="w-5 h-5 rounded object-cover" />
              {g.label}
            </button>
          ))}
        </div>
        {!goutPivoine && <p className="text-xs text-amber-600 mt-1">Veuillez choisir le goût de la pivoine</p>}
      </div>

      {/* 3 Roses */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goûts des 3 Roses :</p>
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${rosesPret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
          {rosesPret ? "✓ Sélection complète !" : `${restantRoses} rose${restantRoses > 1 ? "s" : ""} restante${restantRoses > 1 ? "s" : ""}`}
        </div>
        <div className="space-y-2">
          {GOUTS_ROSES.map((g) => {
            const count = repartitionRoses[g.id];
            return (
              <div key={g.id} className="flex items-center gap-3">
                <img src={g.image} alt={g.label} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" />
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => handleDecreaseRose(g.id)} disabled={count === 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => handleIncreaseRose(g.id)} disabled={restantRoses <= 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantRoses <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 6 Mendiants */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goûts des 6 Mendiants :</p>
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${mendiantsPret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
          {mendiantsPret ? "✓ Sélection complète !" : `${restantMendiants} mendiant${restantMendiants > 1 ? "s" : ""} restant${restantMendiants > 1 ? "s" : ""}`}
        </div>
        <div className="space-y-2">
          {GOUTS_MENDIANTS.map((g) => {
            const count = repartitionMendiants[g.id];
            const isDark = ["noir", "ruby"].includes(g.id);
            return (
              <div key={g.id} className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-lg flex-shrink-0 border border-gray-200 flex items-center justify-center" style={{ background: g.color }}>
                  <span className={`text-xs font-bold ${isDark ? "text-white" : "text-gray-700"}`}>{g.label[0]}</span>
                </span>
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => handleDecreaseMendiant(g.id)} disabled={count === 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => handleIncreaseMendiant(g.id)} disabled={restantMendiants <= 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantMendiants <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Demande particulière */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Demande particulière <span className="text-gray-400 font-normal">(optionnel)</span> :
        </p>
        <GuidePoster image="/images/guides/guide-toppers.jpg" label="Voir des exemples de toppers" />
        <input type="text" value={demande} onChange={(e) => setDemande(e.target.value)}
          placeholder="Ex : topper anniversaire, bébé garçon, prénom..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary" />
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button onClick={handleAddToCart} disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
        {!goutCoeur ? "Choisissez le goût du cœur"
          : !goutPivoine ? "Choisissez le goût de la pivoine"
          : !rosesPret ? "Complétez vos 3 roses"
          : !mendiantsPret ? "Complétez vos 6 mendiants"
          : "Ajouter au panier"}
      </button>
    </div>
  );
};

// ─── Modèle 2 : 6 Fraises Enrobées ──────────────────────────────────────────
const CoeurModel2 = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);
  const [goutCoeur, setGoutCoeur] = useState(null);
  const [repartitionFraises, setRepartitionFraises] = useState({ ...REPARTITION_FRAISES_VIDE });
  const [demande, setDemande] = useState("");

  const totalFraises = Object.values(repartitionFraises).reduce((a, b) => a + b, 0);
  const restantFraises = 6 - totalFraises;
  const fraisesPret = totalFraises === 6;

  const pret = goutCoeur && fraisesPret;

  const handleIncrease = (id) => { if (restantFraises <= 0) return; setRepartitionFraises((p) => ({ ...p, [id]: p[id] + 1 })); };
  const handleDecrease = (id) => { if (repartitionFraises[id] <= 0) return; setRepartitionFraises((p) => ({ ...p, [id]: p[id] - 1 })); };

  const buildDescription = () => {
    const fraises = GOUTS_FRAISES.filter((g) => repartitionFraises[g.id] > 0).map((g) => `${repartitionFraises[g.id]}x ${g.label}`).join(", ");
    return [
      `Coeur : ${goutCoeur?.label}`,
      `Fraises (6) : ${fraises}`,
      demande.trim() ? `Demande : ${demande.trim()}` : null,
    ].filter(Boolean).join("\n");
  };

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart({
      id: `coeur-modele2-${Date.now()}`,
      name: "Cœur en Chocolat Fraises Enrobées",
      price: 25,
      image: "/images/coeurs/coeur-fraises.jpg",
      category: "Cœurs en Chocolat",
      description: buildDescription(),
    }, quantity);
    setGoutCoeur(null);
    setRepartitionFraises({ ...REPARTITION_FRAISES_VIDE });
    setDemande("");
    setQuantity(1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <img src="/images/coeurs/coeur-fraises.jpg" alt="Cœur Fraises Enrobées" className="w-full h-64 object-contain rounded-xl mb-4" />
      <h2 className="text-xl font-semibold mb-1">Cœur Fraises Enrobées</h2>
      <p className="text-gray-500 text-sm mb-3">Contient 6 Fraises Enrobées au Chocolat</p>
      <p className="text-xs text-amber-700 font-medium mb-3">Disponible d'Avril à Septembre, selon l'arrivage</p>
      <p className="text-xl font-bold mb-5">25 €</p>

      {/* Goût du coeur */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goût du Cœur :</p>
        <div className="flex gap-2 flex-wrap">
          {GOUTS_COEUR.map((g) => (
            <button key={g.id} onClick={() => setGoutCoeur(g)}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-all ${goutCoeur?.id === g.id ? "border-primary ring-2 ring-primary ring-offset-1" : "border-gray-200 hover:border-gray-400"}`}>
              <span className="w-5 h-5 rounded-full border border-gray-300 flex-shrink-0" style={{ background: g.color }} />
              {g.label}
            </button>
          ))}
        </div>
        {!goutCoeur && <p className="text-xs text-amber-600 mt-1">Veuillez choisir le goût du cœur</p>}
      </div>

      {/* 6 Fraises */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">Goûts des 6 Fraises Enrobées :</p>
        <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${fraisesPret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
          {fraisesPret ? "✓ Sélection complète !" : `${restantFraises} fraise${restantFraises > 1 ? "s" : ""} restante${restantFraises > 1 ? "s" : ""}`}
        </div>
        <div className="space-y-2">
          {GOUTS_FRAISES.map((g) => {
            const count = repartitionFraises[g.id];
            const isDark = g.id === "lait";
            return (
              <div key={g.id} className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-lg flex-shrink-0 border border-gray-200 flex items-center justify-center" style={{ background: g.color }}>
                  <span className={`text-xs font-bold ${isDark ? "text-white" : "text-gray-700"}`}>{g.label[0]}</span>
                </span>
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => handleDecrease(g.id)} disabled={count === 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => handleIncrease(g.id)} disabled={restantFraises <= 0} className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantFraises <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Demande particulière */}
      <div className="mb-4">
        <p className="text-sm font-semibold mb-2 text-gray-700">
          Demande particulière <span className="text-gray-400 font-normal">(optionnel)</span> :
        </p>
        <GuidePoster image="/images/guides/guide-toppers.jpg" label="Voir des exemples de toppers" />
        <input type="text" value={demande} onChange={(e) => setDemande(e.target.value)}
          placeholder="Ex : topper anniversaire, bébé garçon, prénom..."
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary" />
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button onClick={handleAddToCart} disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}>
        {!goutCoeur ? "Choisissez le goût du cœur"
          : !fraisesPret ? "Complétez vos 6 fraises"
          : "Ajouter au panier"}
      </button>
    </div>
  );
};

// ─── Page principale ──────────────────────────────────────────────────────────
const CoeurChocolat = () => {
  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-4">Cœurs en Chocolat</h1>
      <p className="text-gray-500 mb-12">
        Des cœurs en chocolat garnis selon vos envies.
      </p>
      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <CoeurModel1 />
        <CoeurModel2 />
      </div>
    </div>
  );
};

export default CoeurChocolat;